import React from 'react';
import LegalPageLayout from './LegalPageLayout';

function AboutPage() {
	return (
		<LegalPageLayout title="About Us">
			<p>
				Movie Quotes Guesser is a daily movie quote guessing game that challenges you to identify
				films from a sequence of quotes and sketches. Each day brings a new classic to solve.
			</p>
			<p>
				Our goal is to make movie trivia fun, fast, and shareable. Play the daily puzzle, try Daily
				Five, and compare your results with friends.
			</p>
			<p>
				Have ideas to make the game better? We would love to hear from you at{' '}
				<a href="mailto:contact@moviequotesguesser.com">contact@moviequotesguesser.com</a>.
			</p>
		</LegalPageLayout>
	);
}

export default AboutPage;
